<template>
  <div style="width: 100%;height: 100%; cursor: default;">
    <div style="width: 800px; height: 600px;margin: 0 auto;text-align: center;">
      <h1 style="font-weight: bold;font-size: 260px;color: #333;">404</h1>
    </div>
  </div>
</template>

<script>
import imgUrl from '@/assets/404.png'

export default {
  name: 'index',
  data () {
    return {
      url: imgUrl
    }
  }
}
</script>

<style scoped>

</style>
